import React from 'react';
import { useNavigate } from "react-router-dom";

const Settings = () => {
  const navigate = useNavigate();

  return (
    <div className="settings-container">


      <div className="settings-grid">
        {/* Class Card */}
        <div className="settings-card" onClick={() => navigate("/modules")}>
          <div className="card-icon-wrapper bg-blue-100">
            <i className="ph-duotone ph-chalkboard-simple"></i>
          </div>
          <h3>Class</h3>
          <p>Manage class settings</p>
          <span className="card-action">Configure →</span>
        </div>

        {/* Section Card */}
        <div className="settings-card" onClick={() => navigate("/sections")}>
          <div className="card-icon-wrapper bg-indigo-100">
            <i className="ph-duotone ph-squares-four"></i>
          </div>
          <h3>Section</h3>
          <p>Manage class sections</p>
          <span className="card-action">Configure →</span>
        </div>

        {/* Subject Card */}
        <div className="settings-card" onClick={() => navigate("/subject")}>
          <div className="card-icon-wrapper bg-purple-100">
            <i className="ph-duotone ph-book-open"></i>
          </div>
          <h3>Subject</h3>
          <p>Subject configurations</p>
          <span className="card-action">Configure →</span>
        </div>

        {/* Chapter Card */}
        <div className="settings-card" onClick={() => navigate("/chapter")}>
          <div className="card-icon-wrapper bg-green-100">
            <i className="ph-duotone ph-article"></i>
          </div>
          <h3>Chapter</h3>
          <p>Organize chapters</p>
          <span className="card-action">Configure →</span>
        </div>

        {/* Topic Card */}
        <div className="settings-card" onClick={() => navigate("/topic")}>
          <div className="card-icon-wrapper bg-amber-100">
            <i className="ph-duotone ph-file-text"></i>
          </div>
          <h3>Topic</h3>
          <p>Manage topics</p>
          <span className="card-action">Configure →</span>
        </div>

        {/* Level Card */}
        <div className="settings-card" onClick={() => navigate("/level")}>
          <div className="card-icon-wrapper bg-rose-100">
            <i className="ph-duotone ph-stack"></i>
          </div>
          <h3>Level</h3>
          <p>Difficulty levels</p>
          <span className="card-action">Configure →</span>
        </div>

        {/* Exam Type Card */}
<div className="settings-card" onClick={() => navigate("/exam-type")}>
  <div className="card-icon-wrapper bg-teal-100">
    <i className="ph-duotone ph-graduation-cap"></i>
  </div>
  <h3>Exam Type</h3>
  <p>Manage exam categories</p>
  <span className="card-action">Configure →</span>
</div>
      </div>

      <style>
        {`
          .settings-container {
            min-height: 100vh;
            background: linear-gradient(135deg, #f5f7fa 0%, #e4edf5 100%);
            padding: 1.5rem;
          }
          
          .settings-header {
            max-width: 1200px;
            margin: 0 auto 2rem;
            padding: 0 0.75rem;
          }
          
          .settings-header h1 {
            font-size: 2rem;
            font-weight: 700;
            color: #1a202c;
            margin-bottom: 0.5rem;
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
          
          .settings-header p {
            font-size: 1rem;
            color: #718096;
          }
          
          .settings-grid {
            max-width: 1200px;
            margin: 0 auto;
            display: grid;
            grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
            gap: 1.25rem;
            padding: 0 0.75rem;
          }
          
          .settings-card {
            background: white;
            border-radius: 1rem;
            padding: 1.5rem;
            text-align: center;
            cursor: pointer;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            border: 1px solid #e2e8f0;
            position: relative;
            overflow: hidden;
            display: flex;
            flex-direction: column;
            align-items: center;
            min-height: 180px;
            box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
          }
          
          .settings-card::before {
            content: '';
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            height: 3px;
            background: linear-gradient(90deg, #667eea, #764ba2);
            opacity: 0;
            transition: opacity 0.3s;
          }
          
          .settings-card:hover {
            transform: translateY(-5px);
            box-shadow: 0 12px 24px rgba(0, 0, 0, 0.08);
            border-color: #cbd5e0;
          }
          
          .settings-card:hover::before {
            opacity: 1;
          }
          
          .settings-card:hover .card-action {
            opacity: 1;
            transform: translateX(0);
          }
          
          .card-icon-wrapper {
            width: 60px;
            height: 60px;
            border-radius: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 1rem;
            transition: all 0.3s;
          }
          
          .settings-card:hover .card-icon-wrapper {
            transform: scale(1.08) rotate(3deg);
          }
          
          .card-icon-wrapper i {
            font-size: 1.75rem;
          }
          
          .bg-blue-100 { background-color: #dbeafe; color: #1d4ed8; }
          .bg-indigo-100 { background-color: #e0e7ff; color: #4338ca; }
          .bg-purple-100 { background-color: #f3e8ff; color: #7c3aed; }
          .bg-green-100 { background-color: #dcfce7; color: #16a34a; }
          .bg-amber-100 { background-color: #fef3c7; color: #d97706; }
          .bg-rose-100 { background-color: #ffe4e6; color: #e11d48; }
.bg-teal-100 { background-color: #ccfbf1; color: #0f766e; }
          
          .settings-card h3 {
            font-size: 1.125rem;
            font-weight: 600;
            color: #2d3748;
            margin-bottom: 0.375rem;
          }
          
          .settings-card p {
            font-size: 0.8125rem;
            color: #718096;
            margin-bottom: 0.75rem;
            flex-grow: 1;
            line-height: 1.4;
          }
          
          .card-action {
            font-size: 0.8125rem;
            font-weight: 500;
            color: #4f46e5;
            opacity: 0;
            transform: translateX(-8px);
            transition: all 0.3s;
          }
          
          @media (max-width: 768px) {
            .settings-container {
              padding: 1rem;
            }
            
            .settings-header h1 {
              font-size: 1.75rem;
            }
            
            .settings-header p {
              font-size: 0.9375rem;
            }
            
            .settings-grid {
              grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
              gap: 1rem;
            }
            
            .settings-card {
              padding: 1.25rem;
              min-height: 160px;
            }
            
            .card-icon-wrapper {
              width: 56px;
              height: 56px;
              border-radius: 14px;
            }
            
            .card-icon-wrapper i {
              font-size: 1.5rem;
            }
          }
          
          @media (max-width: 480px) {
            .settings-grid {
              grid-template-columns: 1fr;
              max-width: 280px;
            }
            
            .settings-card {
              min-height: 140px;
              padding: 1rem;
            }
          }
          
          @media (min-width: 768px) and (max-width: 1024px) {
            .settings-grid {
              grid-template-columns: repeat(2, 1fr);
            }
          }
          
          @media (min-width: 1024px) {
            .settings-grid {
              grid-template-columns: repeat(4, 1fr);
            }
          }
        `}
      </style>
    </div>
  );
};

export default Settings;